import template from './security-deposit.jade';

const config = {
  default: {
    required: false,
  },
};

export default angular
  .module('cian.addForm.securityDeposit', [])
  .directive('cianAfPriceAndDealTermsSecurityDeposit', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      'categoryService',
      function ($scope, categoryService) {
        const { objectType } = categoryService.getInfoByCategory(this.ad.category);
        this.config = config[objectType] || config.default;
      },
    ],
    controllerAs: 'securityDeposit',
    template,
  })).name;
